export const pricingField = [

    {
        name: "itemCode",
        label: "Code",
        type: "combobox",
        required: true,
    },

    {
        name: "itemName",
        label: "Name",
        type: "text",
        required: true,
        readonly: true
    },

    {
        name: "retailPrice",
        label: "Retail Price",
        type: "number",
        required: true,
    },

    {
        name: "customerDiscount",
        label: "Customer Discount %",
        type: "number",
        min: 0,
        max: 100,
        helperText: "Applied on Retail Price",
    },

    {
        name: "Valid From",
        label: "Cust Discount Valid From",
        type: "daterange",
    },

      {
        name: "Valid To",
        label: "Cust Discount Valid To",
        type: "daterange",
    },

    {
        name: "hsnCode",
        label: "HSN Code",
        type: "autoComplete",
        fetchFrom: "HSN_MASTER",
        helperText: "Used for IGST / SGST / CGST calculation",
        required: true,
    },



    {
        name: "subscriptionCycle",
        label: "Subscription Cycle",
        type: "select",
        options: ["Weekly", "Fortnightly", "Monthly", "Quarterly"],
    },

    {
        name: "subscriptionDiscount",
        label: "Subscription Discount %",
        type: "number",
        min: 0,
        max: 100,
        helperText: "Applied on Retail Price",
    },

    {
        name: "onPromotion",
        label: "On Promotion",
        type: "select",
        options: ["Yes", "No"],
        defaultValue: "No",
    },

    {
        name: "promotionLabel",
        label: "Promotion Label",
        type: "select",
        options: ["Seasonal", "Clearance", "Holiday", "Sale"],
    },

    {
        name: "promotionalDiscount",
        label: "Promotional Discount %",
        type: "number",
        min: 0,
        max: 100,
        helperText: "Applied on Retail Price",
        dependsOn: {
            field: "onPromotion",
            value: "Yes",
        },
    },

    {
        name: "promotionalPrice",
        label: "Promotional Price",
        type: "number",
        readonly: true,
        helperText: "Auto calculated when promotion is active",
    },


    {
    name: "volumeDiscount",
    label: "Volume Discount %",
    type: "volumeDiscount",
    fields: [
      { name: "Qty", label: "Qty", type: "text" },
      { name: "discount", label: "Discount %", type: "number" },
      { name: "validFrom", label: "Valid From", type: "date" },
      { name: "validTo", label: "Valid To", type: "date" },
    ],
  },

  {
        name: "sellPrice",
        label: "Sell Price",
        type: "number",
        readonly: true,
        helperText: "Auto calculated from Retail Price",
    },

]